export default __webpack_public_path__ + "static/media/100_38904.7ccd2164.jpg";